export default __webpack_public_path__ + "fc0d913460471b86c193bdf3110af9dd.svg";